import i18n from "@/i18n";
import store  from '@/store'
import { MetadataMaskyooStatus } from "@/models/MetadataMaskyooStatus";
import { MultiselectItem } from "@/models/MultiselectItem";
import { AvailableLeadStatuses, AvailableSaleStatuses, LeadStatus } from "@/models/leads/LeadStatus";
import {LeadsPageKind} from "@/models/LeadsPageKind";
import { LeadPriceType } from '@/models/leads/LeadPriceType';
import HelperService from './HelperService';

const namespace = "leadsModule";

export default {
  getLeadsPageKind(queryPageKind: string | (string | null)[]): LeadsPageKind {
    if (queryPageKind)
      return +queryPageKind;
    return LeadsPageKind.Leads;
  },
  
  getAvailableLeadStatuses(filter?: string): MultiselectItem[] {
    const result: MultiselectItem[] = [];
    for (const leadStatus of AvailableLeadStatuses) {
      const title: string = i18n.t(`Enums.LeadStatus.${LeadStatus[leadStatus]}`).toString();
      if (!filter || title.toLowerCase().indexOf(filter.toLowerCase()) >= 0) {
        result.push({
          Id: leadStatus.toString(),
          Title: title,
        });
      }
    }
    return result;
  },

  getAvailableSaleStatuses(filter?: string): MultiselectItem[] {
    const result: MultiselectItem[] = [];
    for (const saleStatus of AvailableSaleStatuses) {
      const title: string = i18n.t(`Enums.LeadStatus.${LeadStatus[saleStatus]}`).toString();
      if (!filter || title.toLowerCase().indexOf(filter.toLowerCase()) >= 0) {
        result.push({
          Id: saleStatus.toString(),
          Title: title,
        });
      }
    }
    return result;
  },

  getCallStatuses(): MultiselectItem[] {
    return [
      {
        Id: "-2",
        Title: i18n.t("Enums.MetadataMaskyooStatus.Forms").toString(),
      },
      {
        Id: "-1",
        Title: i18n.t("Enums.MetadataMaskyooStatus.All").toString(),
      },
      {
        Id: MetadataMaskyooStatus.Answer.toString(),
        Title: i18n.t(`Enums.MetadataMaskyooStatus.${MetadataMaskyooStatus[MetadataMaskyooStatus.Answer]}`).toString(),
      },
      {
        Id: MetadataMaskyooStatus.NotAnswer.toString(),
        Title: i18n.t(`Enums.MetadataMaskyooStatus.${MetadataMaskyooStatus[MetadataMaskyooStatus.NotAnswer]}`).toString(),
      },
      {
        Id: MetadataMaskyooStatus.Callback.toString(),
        Title: i18n.t(`Enums.MetadataMaskyooStatus.${MetadataMaskyooStatus[MetadataMaskyooStatus.Callback]}`).toString(),
      },
      {
        Id: "-3",
        Title: i18n.t("Enums.MetadataMaskyooStatus.WhatsApp").toString(),
      },
    ];
  },

  getPageSize(): number {
    return 30;
  },

  resetFilters(pageKind: LeadsPageKind, clientUser: boolean): void {
    store.dispatch(`${ namespace }/setShowFavourite`, false, { root: true });
    store.dispatch(`${ namespace }/setUniqueByCampaign`, false, { root: true });
    switch (pageKind) {
      case LeadsPageKind.Clients:
        store.dispatch(`${ namespace }/setClientsDatePeriod`, HelperService.getThisMonthPeriod(), { root: true });
        store.dispatch(`${ namespace }/setClientsSearchValue`, "", { root: true });
        store.dispatch(`${ namespace }/setClientsSelectedAdditionalStatusesIds`, [], { root: true });
        store.dispatch(`${ namespace }/setClientsSelectedAdGroupsIds`, [], { root: true });
        store.dispatch(`${ namespace }/setClientsSelectedAdTitles`, [], { root: true });
        store.dispatch(`${ namespace }/setClientsSelectedAssetsIds`, [], { root: true });
        store.dispatch(`${ namespace }/setClientsSelectedAssigneesIds`, [], { root: true });
        store.dispatch(`${ namespace }/setClientsSelectedCallStatusesIds`, [], { root: true });
        store.dispatch(`${ namespace }/setClientsSelectedChannelsIds`, [], { root: true });
        store.dispatch(`${ namespace }/setClientsSelectedChannelMetadataTypesIds`, [], { root: true });
        if (!clientUser) {
          store.dispatch(`${ namespace }/setClientsSelectedCompaniesIds`, [], { root: true });
        }
        store.dispatch(`${ namespace }/setClientsSelectedCommitmentsIds`, [], { root: true });
        store.dispatch(`${ namespace }/setClientsSelectedFoundMetadataTypesIds`, [], { root: true });
        store.dispatch(`${ namespace }/setClientsSelectedLeadStatusesIds`, [], { root: true });
        store.dispatch(`${ namespace }/setClientsSelectedPriceType`, LeadPriceType.CampaignGlobalPrice, { root: true });
        store.dispatch(`${ namespace }/setClientsSelectedSaleStatusesIds`, [], { root: true });
        store.dispatch(`${ namespace }/setClientsSelectedTags`, [], { root: true });
        break
      case LeadsPageKind.Leads:
        store.dispatch(`${ namespace }/setDatePeriod`, HelperService.getThisMonthPeriod(), { root: true });
        store.dispatch(`${ namespace }/setSearchValue`, "", { root: true });
        store.dispatch(`${ namespace }/setSelectedAdditionalStatusesIds`, [], { root: true });
        store.dispatch(`${ namespace }/setSelectedAdGroupsIds`, [], { root: true });
        store.dispatch(`${ namespace }/setSelectedAdTitles`, [], { root: true });
        store.dispatch(`${ namespace }/setSelectedAssetsIds`, [], { root: true });
        store.dispatch(`${ namespace }/setSelectedAssigneesIds`, [], { root: true });
        store.dispatch(`${ namespace }/setSelectedCallStatusesIds`, [], { root: true });
        store.dispatch(`${ namespace }/setSelectedChannelsIds`, [], { root: true });
        store.dispatch(`${ namespace }/setSelectedChannelMetadataTypesIds`, [], { root: true });
        if (!clientUser) {
          store.dispatch(`${ namespace }/setSelectedCompaniesIds`, [], { root: true });
        }
        store.dispatch(`${ namespace }/setSelectedCommitmentsIds`, [], { root: true });
        store.dispatch(`${ namespace }/setSelectedFoundMetadataTypesIds`, [], { root: true });
        store.dispatch(`${ namespace }/setSelectedLeadStatusesIds`, [], { root: true });
        store.dispatch(`${ namespace }/setSelectedPriceType`, LeadPriceType.CampaignGlobalPrice, { root: true });
        store.dispatch(`${ namespace }/setSelectedSaleStatusesIds`, [], { root: true });
        store.dispatch(`${ namespace }/setSelectedTags`, [], { root: true });
        break;
    }
  },
};
